var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEditGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_editGray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**DASHBOARD**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.301217215
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard-expand",
    transform: "translate(-1202.000000, -365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_editGray",
    transform: "translate(1202.000000, 365.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF044",
    transform: "translate(3.000000, 2.000000)",
    fill: "#05315F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9290587,12.8017888 C14.8733948,12.8574527 14.8437146,12.9316713 14.8437146,13.0095863 L14.8437146,17.2214903 L1.78124575,17.2214903 L1.78124575,4.15902148 L10.7431384,4.15902148 C10.8247861,4.15902148 10.8990047,4.12934129 10.9546686,4.07367736 L12.1421658,2.8861802 C12.3277122,2.69690109 12.1940971,2.37777572 11.9306356,2.37777572 L1.78124575,2.37777572 C0.79784966,2.37777572 0,3.17562538 0,4.15902148 L0,17.2214903 C0,18.2048864 0.79784966,19.0027361 1.78124575,19.0027361 L14.8437146,19.0027361 C15.8271107,19.0027361 16.6249604,18.2048864 16.6249604,17.2214903 L16.6249604,11.8257856 C16.6249604,11.5586277 16.3021023,11.4287452 16.1165559,11.6142916 L14.9290587,12.8017888 Z M20.7403947,5.31310579 C21.5864792,4.46702131 21.5864792,3.09028127 20.7366621,2.24046411 L19.1335336,0.637335688 C18.2874492,-0.212445229 16.9144055,-0.212445229 16.0646246,0.637335688 L6.31970425,10.3822561 L5.94861138,13.7369138 C5.84101619,14.7166135 6.66854604,15.5367142 7.64081659,15.429119 L10.9954743,15.0580262 L20.7403947,5.31310579 Z M17.0739682,6.45979724 L10.1753736,13.3546954 L7.75214445,13.625586 L8.02303499,11.2023568 L14.9179332,4.30376219 L17.0739682,6.45979724 Z M19.478679,3.50217986 C19.6308126,3.65434967 19.6308126,3.89925647 19.4823754,4.05512272 L18.335684,5.20177793 L16.1796489,3.04574288 L17.3263404,1.89905143 C17.4747775,1.74691785 17.7233807,1.74691785 17.8755506,1.89905143 L19.478679,3.50217986 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditGray);
export default __webpack_public_path__ + "static/media/ic_editGray.4d5cf7eb9d345d4f927ff240d0f1d9cb.svg";
export { ForwardRef as ReactComponent };